import { GroupItem, ClearAllIcon } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

interface ClearAllChatHistoryProps {
  onClearAllChatHistory: () => void;
}
const ClearAllChatHistory = ({ onClearAllChatHistory }: ClearAllChatHistoryProps) => {
  const { t } = useTranslation();
  return (
    <GroupItem
      icon={<ClearAllIcon />}
      title={t('chatSettings.clearAllChatHistory')}
      onClick={onClearAllChatHistory}
    />
  );
};

const MemoizedClearAllChatHistory = memo(ClearAllChatHistory);
export { MemoizedClearAllChatHistory as ClearAllChatHistory };
